const purchaseType = {
  dp: {
    name: "md",
    label: "MD DP",
    value: "0",
    id: 1
  },
  mdCv: {
    name: "mdCv",
    label: "MD CV",
    value: "1",
    id: 2
  },
  cv: {
    name: "vendor",
    label: "Vendor",
    value: "1",
    id: 3
  },
  others: {
    name: "others",
    label: "Others",
    value: "0,1",
    id: 4
  }
}
const dashboardRolesAccess = [
  {
    name: "Administrator"
  },
  {
    name: "Finance"
  },
  {
    name: "Vendor"
  }
]

const storeTypeMargin = {
  marginMurah : "Margin Murah",
  marginNormal: "Margin Normal"
}

const singleMarginDetailPath = {
  detail: "detail",
}

export default {
  text: {
    err500: "internal server error",
  },
  path: {
    detail: "detail",
    create: "create"
  },
  purchaseType: purchaseType,
  dashboardRolesAccess: dashboardRolesAccess,
  purchaseTypes: [purchaseType.dp, purchaseType.mdCv, purchaseType.cv, purchaseType.others],
  itemTransferStatus: {
    posted: 'Posted',
    draft: 'Draft'
  },
  storeTypeMargin: storeTypeMargin,
  singleMarginDetailPath: singleMarginDetailPath,
}